export default {"src":"/_next/static/media/back.3d2d6219.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};